import { render, staticRenderFns } from "./Housings.vue?vue&type=template&id=63f48a1b&"
import script from "./Housings.vue?vue&type=script&lang=js&"
export * from "./Housings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports